import { createApp } from 'vue'
// import './style.css'
import App from './modules/app/app.vue'
import axios from 'axios'
import router from './routes';
import { Auth } from './modules/auth/auth';
import { Dashboard } from './modules/dashboard/dashboard';
// import { Toast } from './modules/toast/toast';

// axios.defaults.baseURL = 'http://localhost:4000/v1';
// axios.defaults.baseURL = 'https://api.sgiguard.com.ar/v1';
// axios.defaults.baseURL = 'http://192.168.1.6:4000/sgi_api/v1';

console.log(window.SGI_API);
axios.defaults.baseURL = window.SGI_API ?? '';


axios.interceptors.request.use(
    
    async (config) => {

        const organization_id = Dashboard.memberships.getCurrentId();
        config.headers['sgi-organization-id'] = organization_id;

        // M40.2: contexto de space (level 3 space:admin) — sin selección no
        // se envía el header y el backend opera a nivel organización
        const space_id = Dashboard.memberships.getCurrentSpaceId();

        if(space_id)
            config.headers['sgi-space-id'] = space_id;

        const token = await Auth.getToken(false); // 

        if(token)
            config.headers.Authorization = `Bearer ${token}`;

        console.dir(config.headers);

        return config;

    }, (err) => {

        console.log(`Axios error: ${err}`);

    }

)

const app = createApp(App);

app.use(router); // <-- ¡Esta línea es la que probablemente te falta o está mal ubicada!
app.mount('#app');
